import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { finalize, Observable, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { CallService } from '../../services';
import moment from 'moment';
import { SimpleChanges } from '@angular/core';

declare let Enkora : { tt : (a : string) => string };

@Component({
	selector    : 'app-autocomplete-dropdown',
	templateUrl : './autocomplete-dropdown.component.html',
	styleUrls   : ['./autocomplete-dropdown.component.scss']
})
export class AutocompleteDropdownComponent {

	@Input() label : string = '';
	@Input() data_url : string = '';
	@Input() name_fields : string[] = ['name'];
	@Input() sub_name_fields : string[] = ['name'];
	@Input() sub_name_icon : string = null;
	@Input() sub_name_icon_condition : string = null;
	@Input() reset = false;

	@Output() selectionChange = new EventEmitter<any>();

	protected data_list : any[] = [];
	dataController = new FormControl<any>(null);
	dataFilteredController = new FormControl<string>('');
	filteredDataOptions : ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	protected _onDestroy = new Subject<void>();

	constructor(private call : CallService)
	{
	}

	ngOnChanges(changes : SimpleChanges) : void
	{
		if (changes?.['reset']?.currentValue) {
			this.dataController.setValue(null);
			this.dataFilteredController.setValue('');
			this.fetchDataList();
		}
	}

	ngOnInit() : void
	{
		this.fetchDataList();

		this.dataController.valueChanges
		.pipe(takeUntil(this._onDestroy))
		.subscribe(value => {
			this.selectionChange.emit(value);
		});
	}

	private fetchDataList() : void
	{
		this.call.make(this.data_url).subscribe((res) => {
			this.data_list = [{location_id : null, name : Enkora.tt('All' + ' ' + this.label)}];

			//Generate a name field for each item based on the provided name_fields
			res = res.map((item : any) => {
				item = this.generateNamesField(item);
				return item;
			});

			res = res.sort((a : any, b : any) => a.name.localeCompare(b.name));

			this.data_list = this.data_list.concat(res);
			if (res.length > 1) {
				this.dataController.setValue(this.dataController[1]);
			}
			this.filteredDataOptions.next(this.data_list.slice());

			// listen for search field value changes
			this.dataFilteredController.valueChanges
			.pipe(takeUntil(this._onDestroy))
			.subscribe((res) => {
				this.filterData();
			});
		});
	}

	protected filterData()
	{
		if (!this.data_list) return;

		let search = this.dataFilteredController.value;
		if (!search) {
			this.filteredDataOptions.next(this.data_list.slice());
			return;
		}

		search = search.toLowerCase();
		this.filteredDataOptions.next(
			this.data_list.filter(location => location.name.toLowerCase().indexOf(search) > -1)
		);
	}

	private generateNamesField(item : any) : string
	{
		let new_item_name = [];
		let new_subitem_name = [];
		this.name_fields.forEach(name_field => {
			if (item[name_field]) new_item_name.push(item[name_field]);
		});
		this.sub_name_fields.forEach(sub_name_field => {
			if (item[sub_name_field]) new_subitem_name.push(item[sub_name_field]);
		});
		item.name = new_item_name.join(', ');
		item.sub_name = new_subitem_name.join(', ');
		return item;
	}

	public showSubNameIcon(option : any)
	{
		if (!this.sub_name_icon) return false;

		if (!this.sub_name_icon_condition) return true;

		const now = moment();
		const seen = moment(option[this.sub_name_fields[0]]);

		const diffMinutes = now.diff(seen, 'minutes');
		return diffMinutes > parseInt(this.sub_name_icon_condition);
	}
}
